import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AssetlinksService } from 'src/app/services/assetlinks.service';
import { CampaignLoyaltyProgramme, IndefiniteLoyaltyProgramme, Outlet, OutletWithDealz, ShopWithStories, Story } from 'src/app/models/interfaces';
import { GisService } from 'src/app/services/gis.service';
import { LocationService } from 'src/app/services/location.service';
import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { SwiperOptions, Virtual,Pagination,EffectCards,Scrollbar, EffectFlip  } from 'swiper';
import { ShopPage } from 'src/app/pages/shop/shop.page';
import { OutletDealzService } from 'src/app/services/outlet-dealz.service';
// install Swiper modules
SwiperCore.use([Scrollbar]);

@Component({
  selector: 'app-shop-stories-lane',
  templateUrl: './shop-stories-lane.component.html',
  styleUrls: ['./shop-stories-lane.component.scss'],
})
export class ShopStoriesLaneComponent  implements OnInit {
  @Input() shopWithStories:ShopWithStories
  @Input() shopOutlets:Outlet[] | null | undefined
  @Input() cardHeight = '9em'
  @Output() onStorySelectEmit:EventEmitter<Story> = new EventEmitter();
  kmFromUser:string;
  @ViewChild('swiper', { static: true }) swiper?: SwiperComponent;
  swiperConfig: SwiperOptions = {
    slidesPerView:1.5,
    centeredSlides:false,
    centeredSlidesBounds:true,
    scrollbar:false,
    flipEffect:{
      transformEl:'ion-card'
    }
  };
  constructor(
    public assetLinksService:AssetlinksService,
    private modalCtrl:ModalController,
    private gisService:GisService,
    private outletsService:OutletDealzService,
    private locationService:LocationService
  ) { 
  
  }

  ngOnInit() {
 
    if(this.shopWithStories && this.shopWithStories.stories.length == 1){
      this.swiperConfig.slidesPerView = 'auto'
    }
  }

  async viewAction(){
    try {
     
      const modal = await this.modalCtrl.create({
        component: ShopPage,
        mode: 'ios',
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        handle:false,
        componentProps: {
          shop:this.shopWithStories.shop,
          shopOutlets:this.shopOutlets
        }
      });
      await modal.present();
    } catch (error) {
      console.error(error)
    }
  }

  dealSelected(deal){
    this.onStorySelectEmit.emit(deal);
    console.log('emitted from OultetLaneComponent',deal);
  }

  onSwiper(params) {
    const [swiper] = params;
    console.log(swiper);
  }
  
  onBeforeTransitionStart(params) {
    const [swiper, speed, internal] = params;
    console.log('beforeTransitionStart, speed: ' + speed);
  }
  
  onSlideChange() {
    console.log('slide change');
  }
  
  slideNext(){
    this.swiper.swiperRef.slideNext(500);
  }
  
  slidePrev(){
   this.swiper.swiperRef.slidePrev(500);
  }

}
